import { render, staticRenderFns } from "./indexMchatr.vue?vue&type=template&id=3a2e10c6&"
import script from "./indexMchatr.vue?vue&type=script&lang=js&"
export * from "./indexMchatr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports